"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientContact = void 0;
const typeorm_1 = require("typeorm");
const class_transformer_1 = require("class-transformer");
const JournaledEntity_1 = require("../../JournaledEntity");
const Name_1 = require("../../shared/entity/Name");
// eslint-disable-next-line import/no-cycle
const Client_1 = require("./Client");
// eslint-disable-next-line import/no-cycle
const ClientContactPhone_1 = require("./ClientContactPhone");
// eslint-disable-next-line import/no-cycle
const User_1 = require("../../user/entity/User");
const CircularReference_1 = require("../../serialization/CircularReference");
let ClientContact = class ClientContact extends JournaledEntity_1.JournaledEntity {
};
exports.ClientContact = ClientContact;
__decorate([
    (0, typeorm_1.Column)(() => Name_1.Name),
    __metadata("design:type", Name_1.Name)
], ClientContact.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Client_1.Client, (client) => client.contacts),
    (0, CircularReference_1.CircularRef)(),
    __metadata("design:type", Client_1.Client)
], ClientContact.prototype, "client", void 0);
__decorate([
    (0, typeorm_1.RelationId)((cc) => cc.client),
    __metadata("design:type", String)
], ClientContact.prototype, "clientId", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], ClientContact.prototype, "email", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], ClientContact.prototype, "description", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], ClientContact.prototype, "comment", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Boolean)
], ClientContact.prototype, "mainContact", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => ClientContactPhone_1.ClientContactPhone, (phone) => phone.clientContact, {
        cascade: true
    }),
    (0, class_transformer_1.Type)(() => ClientContactPhone_1.ClientContactPhone),
    __metadata("design:type", Array)
], ClientContact.prototype, "phoneNumbers", void 0);
__decorate([
    (0, typeorm_1.OneToOne)(() => User_1.User, (user) => user.clientContact, { nullable: true }),
    (0, typeorm_1.JoinColumn)(),
    __metadata("design:type", User_1.User)
], ClientContact.prototype, "user", void 0);
exports.ClientContact = ClientContact = __decorate([
    (0, typeorm_1.Entity)()
], ClientContact);
